<template>
  <div id="layout">
    <CommonHeader />
    <div class="main" v-if="accountInfo.userID">
      <div class="left-menu">
        <CommonLeftMenu/>
      </div>
      <div class="right-content"><router-view></router-view></div>      
    </div>
    <CommonFooter />
  </div>
</template>

<script>
import CommonHeader from "@/components/common/CommonHeader.vue";
import CommonFooter from "@/components/common/CommonFooter.vue";
import CommonLeftMenu from "@/components/common/CommonLeftMenu.vue";
import { mapState } from "vuex";
export default {
  name: "Layout",
  components: { CommonHeader, CommonFooter ,CommonLeftMenu},
  computed: {
    ...mapState(["accountInfo"])
  },
};
</script>
<style>
#layout {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
#layout .main {
  display: flex;
  font-size: 14px;
  margin: 0px;
  color: #666;
  line-height: 1.42857;
  padding: 0px;
  width: 100%;
  flex: 1;
  box-sizing: border-box;
}
#layout .left-menu{
  background-color: #fff;
  padding-top: 20px;
  width:200px;
  box-shadow: 2px 0px 5px #e9e9e9;
}
#layout .right-content{
  padding: 20px;
  overflow: hidden ; 
  flex:1;
}

#layout .el-breadcrumb {
  margin-bottom: 30px;
}
</style>
